import React from 'react';
import SecondaryAction from '../../_components/actions/SecondaryAction';
import useDialogLauncher from '../../../../hooks/@lore/dialogs-routable/_hooks/useDialogLauncher';
import { useUser } from '@lore/auth';
import { DialogManager } from '../../../dialogs_new/DialogManager';
import GrayTag from '../../_components/tags/_base/GrayTag';
import Dotdotdot from 'react-dotdotdot';
import MiddleDot from '../../../components/MiddleDot';

export default function Header(props) {
  const { supportQuestion } = props;

  const launch = useDialogLauncher();

  function onClickEdit() {
    launch(DialogManager.SupportQuestionUpdate.Config(supportQuestion.id));
  }

  function onClickDelete() {
    launch(DialogManager.SupportQuestionDelete.Config(supportQuestion.id));
  }

  return (
    <div className="flex flex-col space-y-1">
      <div className="text-sm text-cs-gray-500 flex space-x-1">
        {/*<GrayTag label={supportQuestion.data.audience} />*/}
        <div>
          {supportQuestion.data.audience}
        </div>
        <div>
          <MiddleDot />
        </div>
        <div>
          #{supportQuestion.data.order}
        </div>
      </div>
      <div className="flex justify-between">
        <div className="flex flex-1 space-y-0.5 w-full">
          <div>
            <div className="text-lg font-semibold text-cs-gray-900">
              {supportQuestion.data.question}
            </div>
            {/*<div className="text-sm text-cs-gray-500">*/}
            {/*  /!*<GrayTag label={supportQuestion.data.audience} />*!/*/}
            {/*  {supportQuestion.data.audience}*/}
            {/*</div>*/}
          </div>
        </div>
        <div className="flex space-x-2">
          <div>
            <SecondaryAction onClick={onClickEdit} secret={true}>
              Edit
            </SecondaryAction>
          </div>
          <div>
            <SecondaryAction onClick={onClickDelete} secret={true}>
              Delete
            </SecondaryAction>
          </div>
        </div>
      </div>
    </div>
  );
}
